import React from 'react';
import { PostHogFeatureFlags } from '@lib/posthog-feature-flags';
import { usePostHogFeatureFlagPayload } from '@hooks/usePostHogFeatureFlagPayload';
import { WarningAlert } from '@components/alert';

type SitewideBannerPayload = {
  message?: string;
};

const SitewideBanner = () => {
  const sitewideBanner =
    usePostHogFeatureFlagPayload<SitewideBannerPayload | null>(
      PostHogFeatureFlags.sitewideBanner,
      null
    );

  if (!sitewideBanner?.message) {
    return null;
  }

  return (
    <div className="my-5 container mx-auto px-5">
      <WarningAlert text={sitewideBanner.message} />
    </div>
  );
};

export default SitewideBanner;
